import React from 'react';

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY);

export default function StripeWrapper(props)
{
	const options = {
		clientSecret: props.client_secret
	};

	return (
		<Elements stripe={stripePromise} options={options}>
			{props.children}
		</Elements>
	);
}
